var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhiteActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.166 24C16.166 23.4299 16.5969 22.9677 17.1284 22.9677L28.8802 22.9677L24.0268 17.7622C23.651 17.3591 23.651 16.7055 24.0268 16.3023C24.4027 15.8992 25.0121 15.8992 25.3879 16.3023L31.8841 23.2701C32.26 23.6732 32.26 24.3268 31.8841 24.7299L25.3879 31.6977C25.0121 32.1008 24.4027 32.1008 24.0268 31.6977C23.651 31.2945 23.651 30.6409 24.0268 30.2378L28.8802 25.0323H17.1284C16.5969 25.0323 16.166 24.5701 16.166 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhiteActions);
export default __webpack_public_path__ + "static/media/ArrowWhiteActions.29637733007bed8469c7ca5e9a2f6994.svg";
export { ForwardRef as ReactComponent };